// extracted by mini-css-extract-plugin
export default {"wrapper":"DownloadReportPage_wrapper__W8qo3"};